import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail',
  standalone: true,
})
export class MaskEmailPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    const trimmed = value.trim();
    const atIndex = trimmed.indexOf('@');
    if (atIndex <= 0) {
      return trimmed;
    }
    const localPart = trimmed.slice(0, atIndex);
    const domain = trimmed.slice(atIndex);
    const visible = localPart.length > 1 ? localPart.charAt(0) : localPart;
    return `${visible}***${domain}`;
  }
}
